import pubStatusIcon from './publish-status-icon/publishStatusIcon';
import workflowStatus from './workflow-status/workflowStatus';
import creatorsListCompact from './creators-list-compact/creatorsListCompact';
import storyHeadline from './story-headline/storyHeadline';
import webskedTime from './websked-time/webskedTime';
import killedMessage from './story-killed-message/storyKilledMessage';
import timePicker from './time-picker/timePicker';
import pitchStatusIcon from './pitch-status-icon/pitchStatusIcon';
import tagsBar from './tags-bar/tagsBar';

const toLoad = [
  pubStatusIcon,
  workflowStatus,
  creatorsListCompact,
  storyHeadline,
  webskedTime,
  killedMessage,
  timePicker,
  pitchStatusIcon,
  tagsBar
];

export default function (ngModule) {
  toLoad.forEach(fn => fn(ngModule));
}
